module.exports = __webpack_public_path__ + "img/person-2.5dcdfcf4.svg";